function openAccordionTabs() {
    const accordionItems = document.querySelectorAll(".baseAccordion__item__title");

    if (!accordionItems) {
        return;
    }

    accordionItems.forEach(item => {
        item.addEventListener("click", () => {
            const accordionItem = item.closest('.baseAccordion__item');
            const accordionItemContent = accordionItem.querySelector('.baseAccordion__item__content');

            accordionItem.classList.toggle('active');

            accordionItemContent.style.maxHeight = accordionItem.classList.contains('active') ? accordionItemContent.scrollHeight + 'px' : null;
        });
    });
}

export default openAccordionTabs;